import script from "./LinksContacto.vue?vue&type=script&setup=true&lang=js"
export * from "./LinksContacto.vue?vue&type=script&setup=true&lang=js"

import "./LinksContacto.vue?vue&type=style&index=0&id=22f6cc71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f6cc71"]])

export default __exports__